import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_FEATURES_QUERY_KEY } from '@/state/queries/features/use-get-features';
import type { Feature, CreateFeatureDto } from '@/types/features';

export const useCreateFeatureMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newFeature: CreateFeatureDto) => {
      const token = await getToken();
      return createFeature(newFeature, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FEATURES_QUERY_KEY] });
      // Invalidate all feature access checks to refresh frontend with updated feature flag data
      queryClient.invalidateQueries({ queryKey: ['check-feature-access'] });
    },
  });
};

const createFeature = async (data: CreateFeatureDto, token: string): Promise<Feature> => {
  const url = `${import.meta.env.VITE_API_URL}/features`;
  return sendJSONRequest({ url, method: METHOD.POST, body: data, token }) as Promise<Feature>;
};
